import React from 'react';
import { withStyles, AppBar, Typography, Hidden } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { FuseNavigation, FuseLayouts } from '@fuse';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';

import { USER } from '../graphql/query';
// import classNames from 'classnames'
import { get } from 'lodash';

const styles = theme => ({
  root: {
    '& .user': {
      '& .username, & .email & .project': {
        transition: theme.transitions.create('opacity', {
          duration: theme.transitions.duration.shortest,
          easing: theme.transitions.easing.easeInOut,
        }),
      },
    },
  },
  avatar: {
    width: 72,
    height: 72,
    position: 'absolute',
    top: 92,
    padding: 8,
    background: theme.palette.background.default,
    boxSizing: 'content-box',
    left: '50%',
    transform: 'translateX(-50%)',
    '& > img': {
      borderRadius: '50%',
    },
  },
});

function MainNavbar({ classes, navigation, layoutStyle, user }) {
  function UserHeader() {
    return (
      <AppBar
        position="static"
        color="primary"
        elevation={0}
        className="user relative flex flex-col items-center justify-center pt-24 pb-64 mb-32 z-0"
      >
        <Query query={USER}>
          {({ data, loading }) => {
            if (loading) return null;
            const email = get(data, 'me.emailAddress', '');
            const firstName = get(data, 'me.firstName', '');
            const lastName = get(data, 'me.lastName', '');
            const role = get(data, 'me.role', '')
              .replace('_', ' ')
              .toLowerCase();

            const displayName = `${firstName} ${lastName ? `${lastName[0]}.` : ''}`;
            return (
              <div className="flex flex-col items-center">
                <Typography
                  className="mb-8"
                  style={{ textTransform: 'capitalize' }}
                  variant="body1"
                >
                  {displayName}
                </Typography>
                <Typography className="mb-8" variant="caption">
                  {email}
                </Typography>
                <Typography
                  className="mb-8"
                  style={{ textTransform: 'capitalize' }}
                  variant="caption"
                >{`(${role})`}</Typography>
              </div>
            );
          }}
        </Query>
      </AppBar>
    );
  }

  const navigationLayout = FuseLayouts[layoutStyle].type;
  return (
    <div className={classes.root}>
      {navigationLayout === 'vertical' ? (
        <React.Fragment>
          <UserHeader />
          <FuseNavigation navigation={navigation} layout={navigationLayout} />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Hidden lgUp>
            <UserHeader />
          </Hidden>
          <FuseNavigation navigation={navigation} layout={navigationLayout} />
        </React.Fragment>
      )}
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

function mapStateToProps({ fuse, auth }) {
  return {
    navigation: fuse.navigation,
    layoutStyle: fuse.settings.current.layout.style,
    user: auth.user,
  };
}

export default withStyles(styles, { withTheme: true })(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(MainNavbar)
  )
);



// WEBPACK FOOTER //
// ./src/main/MainNavbarContent.js